import { CollectiveOperationsList } from '@Resources/collective_operations/CollectiveOperationsList';
import { CollectiveOperationsShow } from '@Resources/collective_operations/CollectiveOperationsShow';
import { ResourceDefinition } from '@Utils/types';

export const collectiveOperationsResource: ResourceDefinition = {
  options: { label: 'menu.collective_operations' },
  list: CollectiveOperationsList,
  show: CollectiveOperationsShow,
};
